// 供应商
export const tipContentSupplierData = function (rateNum) {
  return `<div
      class="Section0"
      style="layout-grid: 15.6pt"
    >
      <p
        class="MsoNormal"
        style="
          text-indent: 24pt;
          mso-char-indent-count: 2;
          line-height: 22px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方使用</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">易派客电子商务平台（</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">以下称</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">“平台”</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">www.epec.com</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">）</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">“询比价服务”功能，</font>
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              应当认真阅读并遵守本协议、《平台会员及用户服务协议》以及易派客电子商务平台发布的各项规则、政策、声明、公告等相关内容与文件。前述各项规则、政策、声明等相关内容与文件为本协议不可分割的一部分，与本协议正文具有同等法律效力。
            </font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="
          text-indent: 24pt;
          mso-char-indent-count: 2;
          line-height: 22px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">本协议是甲乙双方就</font>
          <font face="仿宋_GB2312">“询比价服务”功能的使用所订立的有效合同。</font>
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">乙方每次参与询比价报价前点击或勾选本页面上的</font>
            <font face="仿宋_GB2312">
              “已阅读并同意《询比价服务协议》”键即表示乙方与易派客已达成本协议并同意接受本协议全部约定内容的约束
            </font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="
          text-indent: 24pt;
          mso-char-indent-count: 2;
          line-height: 22px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第一条</font>
          <font face="仿宋_GB2312">合作事项</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">1.1甲方同意乙方使用</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">平台</font>
          <font face="仿宋_GB2312">“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ”功能向在本平台发布的公开询价或向乙方发布的定向询价进行报价。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">1.</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          2
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方应遵守平台设定的</font>
          <font face="仿宋_GB2312">
            “询比价服务”流程、规则，乙方如使用本功能成功中选（即某一询价单的采购商确认乙方中选）的，还应按照本协议约定的条款向甲方支付服务费。
          </font>
        </span>
        <b>
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <b>
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              1.3本平台不得交易危险物品（危险物品，是指枪支弹药、爆炸物品、剧毒化学品、易制爆危险化学品和其他危险化学品、放射性物品、核材料、管制器具等能够危及人身安全和财产安全的物品）以及国家法律法规规章、国家相关政策等规范性文件、易派客平台各项平台规则所禁止交易的各类物资，且不得发布关于前述物资的任何相关信息。
            </font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第二条</font>
          &nbsp;
          <font face="仿宋_GB2312">双方的权利和义务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.1甲方的权利和义务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.1.1甲方提供平台供乙方使用，支持查看通知公告、查看采购寻源信息、线上提交报价、订单确认、订单执行等功能，并及时解答乙方在使用相关功能过程中遇到的问题。甲方客服电话为：
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(51, 51, 51);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          400-819-8786
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(51, 51, 51);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">，服务时间为周一至周五</font>
          <font face="仿宋_GB2312">08:00-12:00，13:00-17:00（法定节假日除外）</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.1.2
            甲方应对平台功能开展技术运维、信息安全防护，维护平台正常运行，并持续完善功能提升平台易用性。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.1.3
            甲方可根据乙方在平台申请的产品类目，以站内信或短信等方式向乙方推送采购商发布的同类产品询价信息。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <b>
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            2.1.4
          </span>
        </b>
        <b>
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">如乙方的报价成功中选，</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">甲方有权按照本协议约定的服务费收取标准向乙方收取服务费。</font>
            <font face="仿宋_GB2312">甲方有权单方面确定、调整收费标准和收费方式。</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">甲方有权对乙方使用</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">平台</font>
          <font face="仿宋_GB2312">“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ”功能的行为进行管理和监督，如乙方行为违反本协议或本平台其他协议、规则的，甲方有权进行相应处理。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          2.1.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">6</font>
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              甲方仅为乙方提供平台服务，不介入乙方与平台采购商之间的任何合同关系，对于乙方基于平台
            </font>
            <font face="仿宋_GB2312">
              “询比价服务”功能产生的交易订单引发的任何风险、争议或纠纷，甲方不承担任何法律责任，包括但不限于产品质量责任、违约责任、侵权责任等
            </font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-heigh: 22p'x; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">7</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          &nbsp;
          <font face="仿宋_GB2312">甲方有权对本平台</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ”功能的使用情况依法进行数据存储，并有权对乙方在本平台开展的各项活动和数据进行分析，此类分析产生的结果归甲方所有。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.2乙方的权利和义务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.2.1使用平台“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">”功能参加报价的，乙方应满足以下条件：</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">
            1）为依法注册且有效存续的法人或其他组织，已开通平台供应商资格；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">2）不存在违反法律法规强制性规定情形；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">3）不存在本协议规定的暂停或取消报价资格情形；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">4）已开通平台在线支付功能。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.2.2 通过资格审核后，乙方有权自主决定是否参加采购商发布的询比价。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.2.3 乙方有权对平台功能提出合理的优化建议。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.2.4乙方应在采购商向乙方发送《中选通知书》后的30个日历日内，按照本协议约定的收费标准和付款条件，通过在线支付向甲方支付服务费。乙方未按约定缴纳中选服务费的，甲方有权将其纳入该询价单采购商的“黑名单”，乙方后续将无法对该采购商发布的询价单进行报价，并计入1次“中选后不缴纳服务费”违约记录。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.2.5乙方缴纳服务费并点击“确认中选”后，采购商方可生成交易订单，乙方应及时确认订单。确认订单后，乙方可与采购商就具体权利义务条款另行约定，并需按照约定完成发货义务。
          </font>
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              如乙方与采购商自行协商一致取消交易的，乙方仍需按照本协议约定向甲方支付服务费。
            </font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 20pt; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.2.6乙方应妥善保管其在本平台的账号和密码、用于收付相关款项的银行卡卡号、密码、有效期等银行卡信息和在线收付软件（包括但不限于“在线支付”）的用户名及支付密码（包括但不限于数字密码），不得以任何形式出借、出租、转让前述账号、密码或其他信息，并应确保用于使用本平台的电脑终端、移动终端设备在安全、未被病毒袭击、未被入侵、未被监控、未被非法控制的环境下运行和使用。
          </font>
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              如因乙方未能履行上述妥善保管及安全使用义务而导致的任何损失或后果，均由乙方自行承担，本平台对此不承担任何赔偿或法律责任
            </font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 20pt; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="
          text-align: center;
          line-height: 21px;
          mso-line-height-rule: exactly
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第三条</font>
          &nbsp;
          <font face="仿宋_GB2312">结算与付款</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="
          mso-para-margin-top: 0.5gd;
          mso-para-margin-bottom: 0.5gd;
          mso-layout-grid-align: none;
          layout-grid-mode: char;
          line-height: 22px;
          mso-line-height-rule: exactly;
        "
      >
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">3.1 服务费收取标准：乙方成功中选的报价金额的【</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">${rateNum}</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">】</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">‰</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              mso-bidi-font-weight: normal;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">。</font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="
          mso-para-margin-top: 0.5gd;
          mso-para-margin-bottom: 0.5gd;
          mso-layout-grid-align: none;
          layout-grid-mode: char;
          line-height: 22px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">3</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          &nbsp;
          <font face="仿宋_GB2312">如乙方使用</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">平台</font>
          <font face="仿宋_GB2312">“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">”功能参加报价并中选的，</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">应于</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">收到《中选通知书》</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">后</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">30个日历日内</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">按照平台提示</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            支付服务费。乙方支付服务费后方可确认中选并生成订单，并在本平台完成后续交易。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="
          margin-top: 7.8pt;
          margin-bottom: 7.8pt;
          margin-left: 18pt;
          mso-para-margin-top: 0.5gd;
          mso-para-margin-bottom: 0.5gd;
          text-indent: -18pt;
          mso-char-indent-count: -1.5;
          mso-layout-grid-align: none;
          layout-grid-mode: char;
          line-height: 22px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            3.3乙方完成服务费支付后，甲方将根据付款情况向乙方开具增值税专用发票。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="
          text-align: center;
          line-height: 21px;
          mso-line-height-rule: exactly
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第四条</font>
          &nbsp;
          <font face="仿宋_GB2312">质量</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">控制</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            .1乙方保证交易商品质量合格，符合国家相关法律法规的强制性规定，并符合其在本平台商品展示页所承诺的质量标准或采购商发布询比价时的质量要求，如采购方与乙方对产品质量另有更高标准的约定，乙方应按照其与采购商的约定履行交货义务。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            .2乙方保证对采购商的订单服务满足相关法律法规和行业规范要求，在依法依规前提下，基于对采购商的订单或合同约定服务采购商的个性化需求。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 20pt; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">.</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          3
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            乙方应按照法律规定或其与采购商的约定为采购商提供售后服务，甲方就乙方向采购商提供的各项服务不承担任何法律责任。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="
          text-align: center;
          line-height: 21px;
          mso-line-height-rule: exactly
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第五条</font>
          &nbsp;
          <font face="仿宋_GB2312">违约处理</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 楷体_GB2312;
            mso-hansi-font-family: 宋体;
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            5.1乙方因履约情况、商品质量、售后服务等问题遭到投诉或举报的，甲方有权暂停乙方在本平台的报价资格，直至该争议处理完毕。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            5.2乙方出现下列情形之一的，甲方有权暂停乙方在本平台的报价资格6个月：
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          1
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">）乙方中选后不缴纳服务费，出现两次及以上的；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">2）乙方因不缴纳服务费情形</font>
          <font face="仿宋_GB2312">被暂停过交易资格，再次出现中选后不缴纳服务费行为的；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">3）乙方因出现产品质量问题受到行政主管部门处罚的；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">
            4）乙方发生破产、清算、重组，或者资信情况、经营状况恶化，甲方认为存在履约风险的；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            5.3如乙方受到中国石化处罚，被暂停或取消交易资格的，甲方有权按照中国石化对乙方的处罚时长暂停其询比价报价权限。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5.4</font>
          <font face="仿宋_GB2312">乙方因上述</font>
          <font face="仿宋_GB2312">
            5.1、5.2、5.3规定的情形被暂停报价权限的，期满后，乙方可提出权限申请，经甲方审核满足条件的，可重新赋予报价权限。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            5.5乙方出现下列情形之一的，甲方有权永久取消乙方在本平台的报价资格：
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          1
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ）引发重、特大质量事故或引发突发环境事件、环保处罚、生态损害赔偿等环保事件的；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">2）经法院审判认为乙方构成犯罪的;</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">
            3）乙方违反在易派客平台签署的《廉洁从业责任书》或《合规承诺函》的。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            5.6报价资格暂停或取消后，乙方将无法参与平台新的询比价报价；已经报价但未明确中选结果的，采购商将无法再将乙方确定为中选供应商；已经中选的，由发布询比价的采购商决定是否继续开展交易。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">7</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          &nbsp;
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            乙方的行为违反上述多项条款的，按较重的规定处罚；出现多次违约行为，或在问题核实调查中态度恶劣，不积极配合的，视情况加重处理。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            5.8发生本协议规定的违约情形的，乙方已支付的服务费甲方不予退还。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            5.9
            若乙方存在其他违反法律法规、本协议约定、其他平台协议或平台规则的，甲方有权酌情对乙方进行处理;
          </font>
          <font face="仿宋_GB2312">甲方有权自行决定将乙方违约行为在平台公示，并有权决定暂停或</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">永久性终止乙方使用本平台部分或全部功能</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            10因乙方原因导致任何第三方向甲方索赔或主张权利的，甲方有权向乙方追偿。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">11本协议有效期间，乙方违反本协议或违法违规使用平台“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ”功能开展业务，对第三方造成任何损害的，乙方应当向第三方承担损害赔偿责任，乙方向第三方承担损害赔偿责任后，无权向甲方追偿。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">12</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">因乙方违约</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">导致</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">本协议终止的，</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">对</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">甲方或任何第三方造成的一切损失应由乙方承担。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            13因乙方违约向甲方赔偿的全部损失，包括但不限于直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            14因乙方违约对甲方造成损失或致使甲方声誉受到负面影响的，乙方应负责及时消除影响。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="
          margin-top: 7.8pt;
          margin-bottom: 7.8pt;
          margin-left: 18pt;
          mso-para-margin-top: 0.5gd;
          mso-para-margin-bottom: 0.5gd;
          text-indent: -18pt;
          mso-char-indent-count: -1.5;
          mso-layout-grid-align: none;
          layout-grid-mode: char;
          text-align: center;
          line-height: 22px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第六条</font>
          &nbsp;
          <font face="仿宋_GB2312">保密条款</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          6
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            .1
            乙方应对本协议及因本协议的签订和履行而签署的其他协议中所约定属于保密信息的内容负有保密义务，未经甲方或其他相关方书面授权，不得将保密信息以任何方式提供给第三方，不得将保密信息用于与本协议无关的活动、宣传，不得利用保密信息与披露方以外的第三方从事商业交易，但与甲方另有约定的除外。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">6</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .2
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            甲方有权根据法律法规的规定，或应司法机关、政府有关部门的要求，或基于依法依规开展的内部审计工作需要以及为开展投标工作需要而在必要范围内向有关第三方提供相关保密信息。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          6.3
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            本协议终止时，乙方所掌握的所有保密信息及其复印件，无论其为电子或书面等任何形式，均应立即销毁。本条约定的保密义务在本协议终止后仍然有效。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          6.4
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            本协议约定的保密信息是指：在乙方与甲方及平台采购商沟通交流过程中，一方以书面或口头等方式向乙方提供的通讯、信息、产品、数据、设计、图纸等资料，包括但不限于商业计划、贸易数据、财务数据、生产经营、专有技术、研究成果、技术秘密等。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">6.5 以下各项不属于本协议所称“保密信息”：</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">1）在本协议签订时已为一方合法获取的信息；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">2）在本协议签订时已为公众所知的信息；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">
            3）一方从不承担保密义务的第三方所获取的信息，并且以一方所了解为限，该第三方对该等信息的获取和/或披露不是非法的；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">4）在没有接触保密信息的情况下，一方独立开发取得的信息；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">5）一方事先征得另一方书面同意而发布的信息。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            6.6
            双方一致认可，在乙方使用“询比价服务”功能过程中，一般不会向甲方披露任何保密信息。如乙方因本协议的履行确需向甲方披露任何保密信息的，应确保其向甲方提供的保密信息是其有权提供的，不会侵犯任何第三方的合法权益。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="
          margin-top: 7.8pt;
          margin-bottom: 7.8pt;
          margin-left: 18pt;
          mso-para-margin-top: 0.5gd;
          mso-para-margin-bottom: 0.5gd;
          text-indent: -18pt;
          mso-char-indent-count: -1.5;
          mso-layout-grid-align: none;
          layout-grid-mode: char;
          text-align: center;
          line-height: 22px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第七条</font>
          &nbsp;
          <font face="仿宋_GB2312">变更及终止</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 楷体_GB2312;
            mso-hansi-font-family: 宋体;
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">7.1双方经协商一致可变更或解除本合同。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            7.2在不影响甲方本合同项下任何索赔权利的情况下，乙方有下列情形之一者，甲方有权单方书面通知乙方解除本合同，乙方应向甲方赔偿因此给甲方造成的损失：
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            7.2.1未经甲方书面同意，将本合同项下部分或全部权利义务转让给第三方。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">7.2.2发生破产、清算、重整等情况，影响履约能力。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            7.2.3被中国石化暂停或取消交易资格，或被列入中国石化或物资装备部（国际事业公司）失信名单。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">7.2.4违反《廉洁从业责任书》或《合规承诺函》；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">7.2.5违反本合同项下合规条款；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">7.2.6违反本合同项下保密条款；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            7.2.7任何一方在本协议项下的承诺、声明或保证若在任一实质方面被证明是虚假的或具误导性的，或有其他严重违约行为，导致本合同目的无法实现；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">7.2.</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          8
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">发生其他严重影响甲方利益及本合同目的实现的重大事项。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">7</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .3
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">如因甲方业务调整，可提前</font>
          <font face="仿宋_GB2312">3</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          0
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            日书面通知乙方解除本协议，对于未缴纳服务费的协议自通知到达自动终止。
          </font>
          <font face="仿宋_GB2312">
            7.3 本协议终止后乙方须继续对已发生未完结的交易订单提供相关服务。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            7.4本合同的解除、终止、无效、被撤销等均不影响乙方基于本合同项下服务与采购商订立的合同的履行。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第八条</font>
          &nbsp;
          <font face="仿宋_GB2312">合规条款</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            8.1甲、乙双方承诺已取得开展本协议项下业务所需的所有国家（地区）相关的执照、批准、许可、资质，知晓并严格遵守任何适用的国家（地区）的强制性法律法规。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            8.2乙方需确保本协议项下询比价交易真实性，且乙方在本平台上所有交易行为依法合规。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第九条</font>
          &nbsp;
          <font face="仿宋_GB2312">免责条款</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9.1 不可抗力</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9.1.1</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            不可抗力是在本合同订立后发生的一方或双方在订立本合同时不能预见、不能避免并不能克服的客观情况，不可抗力事件包括但不限于传染性疾病、自然灾害、战争、火灾、洪水、爆炸、暴乱、罢工等
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">,</font>
          <font face="仿宋_GB2312">及不受甲方所控制的网络攻击、网络故障等。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            因不可抗力事件导致不能履行或不能如期履行本合同义务，遭受不可抗力的一方不承担违约责任。受不可抗力影响的一方应在不可抗力事件发生后
          </font>
          24小时内通知对方，并在其后14个日历日内向对方提供有效证明文件。任何一方故意或过失行为不应被视为不可抗力而免除责任。本合同项下付款义务不受不可抗力事件的影响。
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9.1.2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            受不可抗力影响一方应采取措施，将不可抗力造成的损失减少到最低限度，否则应承担因消极不作为而导致损失扩大的责任。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9.1.3</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            如甲方因不可抗力导致不能按期履行本合同项下义务，乙方可以要求在不可抗力影响范围内顺延相关义务。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9.1.4</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">如不可抗力事件影响持续</font>
          90（含）个日历日以上，双方将就
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">本合同项下</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            等相关问题进行协商。协商一致的，双方应签订变更合同；协商不成的，任何一方有权以书面形式要求解除本合同。因不可抗力事项导致合同解除的，甲乙各自承担因此造成的一切损失。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9.2 其他情形</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9.2.1</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">凡在本</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">平台</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">以</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">账号和密码登陆后进行的操作，均被视为</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">的行为，</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            当对以其账号进行的所有活动和事件以及通过其账号向易派客公司提交的文件材料承担全部法律责任。严禁
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">将其账号、密码转让或出租、出借予他人使用。如</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">发现其账号遭他人非法使用，应立即通知</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">甲方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            。因网络黑客行为、用户故意或者过失导致账号、密码遭他人非法使用，
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">甲方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">不承担任何责任。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9.2.2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">如因</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">自身终端设备和网络异常等原因导致无法正常</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">使用</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">平台</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">“询比价服务”功能</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">的，后果由</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">自行承担，</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">甲方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">不承担任何责任。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第十条</font>
          &nbsp;
          <font face="仿宋_GB2312">法律适用和争议解决</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">10</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            双方在履行本协议过程中如发生争议，应协商解决。协商不成的，提交甲方住所地有管辖权的法院解决。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第十一条</font>
          &nbsp;
          <font face="仿宋_GB2312">生效及其它</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">11</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">本协议一经乙方点击或勾选本页面上的</font>
          <font face="仿宋_GB2312">
            “同意”键将自动生效；供应商中选并支付服务费后，本协议履行完毕而自然终止。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">11.2 甲方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            有权根据国家法律法规变化及运营需要不时变更本协议，但变更后的协议将至少在平台上公示七日后方予实施，乙方应当及时查阅并了解相关变更内容。若乙方不同意变更后的协议，应自公示之日起七日内及时以书面形式向易甲方作出明确表示，否则，即表示乙方已接受变更后的协议，发生争议时，双方将以变更后的协议版本为准。如乙方不同意本协议变更后的内容并按前述期限及形式向甲方作出了明确表示，则乙方应及时按照变更前的协议内容履行完本协议项下相应责任义务后，再次通知甲方，甲方将就乙方前述责任义务履行情况进行确认，并将于确认乙方已履行完相关责任义务后为乙方关闭使用权限，本协议亦将自乙方使用权限关闭时自行终止。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 22px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">11.3本协议未尽事宜，双方通过友好协商以补充</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">协议</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">方式解决。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
    </div>`;
};

// 采购商
export function tipContentPurchaserData(rateNum) {
  return `<div
      class="Section0"
      style="layout-grid: 15.6pt"
    >
      <p
        class="MsoNormal"
        style="
          text-indent: 24pt;
          mso-char-indent-count: 2;
          line-height: 21px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方使用甲方易派客电子商务平台（</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">以下称</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">“平台”</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">www.epec.com</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">）</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">“询比价服务”功能，达成本服务协议</font>
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              应当认真阅读并遵守本协议、《平台会员及用户服务协议》以及易派客电子商务平台发布的各项规则、政策、声明、公告等相关内容与文件。前述各项规则、政策、声明等相关内容与文件为本协议不可分割的一部分，与本协议正文具有同等法律效力。
            </font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="
          text-indent: 24pt;
          mso-char-indent-count: 2;
          line-height: 21px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">本协议是甲乙双方就</font>
          <font face="仿宋_GB2312">“询比价服务”功能的使用所订立的有效合同。</font>
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">乙方点击或勾选本页面上的</font>
            <font face="仿宋_GB2312">
              “已阅读并同意《询比价服务协议》”键即表示乙方与易派客已达成本协议并同意接受本协议全部约定内容的约束
            </font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="
          text-indent: 24pt;
          mso-char-indent-count: 2;
          line-height: 21px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第一条</font>
          <font face="仿宋_GB2312">合作事项</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">1.1甲方同意乙方使用</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">平台</font>
          <font face="仿宋_GB2312">“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ”功能在本平台发布公开询价或定向询价，并对供应商的报价进行比选。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">1.</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          2
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方应遵守平台设定的</font>
          <font face="仿宋_GB2312">
            “询比价服务”流程、规则，供应商如使用本功能成功中选（即某一询价单的由乙方确认供应商中选）的，中选供应商还应按照本协议约定的条款向甲方支付服务费。
          </font>
        </span>
        <b>
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <b>
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              1.3本平台不得交易危险物品（危险物品，是指枪支弹药、爆炸物品、剧毒化学品、易制爆危险化学品和其他危险化学品、放射性物品、核材料、管制器具等能够危及人身安全和财产安全的物品）以及国家法律法规规章、国家相关政策等规范性文件、易派客平台各项平台规则所禁止交易的各类物资，且不得发布关于前述物资的任何相关信息。
            </font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第二条</font>
          &nbsp;
          <font face="仿宋_GB2312">双方的权利和义务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">2.1甲方的权利和义务</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.1.1甲方通过平台为乙方提供完整的线上询比价功能，支持采购计划管理、询比价公告发布、询比价结果编制、中选结果发送、订单确认等业务开展。甲方及时解答乙方在使用相关功能过程中遇到的问题。甲方客服电话为：
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(51, 51, 51);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          400-819-8786
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(51, 51, 51);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">，</font>
          <font face="仿宋_GB2312">服务时间为周一至周五</font>
          <font face="仿宋_GB2312">08:00-12:00，13:00-17:00（法定节假日除外）</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1.2
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            甲方通过平台整合批量供应商资源，并在平台上将乙方发布的询价信息向平台会员进行展示，有报价权限的供应商可直接在线提交报价信息。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.1.3
            甲方应对平台功能开展技术运维、信息安全防护，维护平台正常运行，并持续完善功能提升平台易用性。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            4甲方应当充分考虑乙方对平台功能提出的意见建议，持续对平台“询比价服务”功能进行优化以提升使用体验。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            5甲方有权根据平台规则对乙方发布的询比价信息进行审核，审核通过后方可发布。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="
          margin-top: 7.8pt;
          margin-bottom: 7.8pt;
          mso-para-margin-top: 0.5gd;
          mso-para-margin-bottom: 0.5gd;
          mso-layout-grid-align: none;
          layout-grid-mode: char;
          line-height: 21px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">6 甲方有权向询比价中选的供应商收取平台服务费。</font>
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">服务费收取标准：成功中选的供应商报价金额的【</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">${rateNum}</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">】</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">‰</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            &nbsp;
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">。甲方有权单方面确定、调整收费标准和收费方式。</font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1.7甲方有权对乙方使用
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">平台</font>
          <font face="仿宋_GB2312">“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ”功能的行为进行管理和监督，如乙方行为违反本协议或本平台其他协议、规则的，甲方有权进行相应处理。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1.8 甲方有权对本平台
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ”功能的使用情况依法进行数据存储，并有权对乙方在本平台开展的各项活动和数据进行分析，此类分析产生的结果归甲方所有。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.1.</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          9
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              甲方仅为乙方提供平台服务，不介入乙方与平台供应商之间的任何合同关系，对于乙方基于平台
            </font>
            <font face="仿宋_GB2312">“询比价</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">服务</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              ”功能产生的交易订单引发的任何风险、争议或纠纷，甲方不承担任何法律责任，包括但不限于产品质量责任、违约
            </font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">责任</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">、</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">侵权责任</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">等。</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">2.2乙方的权利和义务</font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.2.1使用平台“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">”功能进行询价采购的，乙方应满足以下条件：</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">
            1）为依法注册且有效存续的法人或其他组织，已开通平台采购商资格；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">2）不存在违反法律法规强制性规定情形；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">3）不存在本协议规定的暂停或取消报价资格情形；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          2.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.2乙方可使用平台“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ”功能开展采购寻源，包括以公开询价或定向询价方式发布询价单、设置审批流程、选商定价、生成订单等。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          2.2.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">3乙方有权对平台功能提出合理的优化建议。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.2.4
            乙方在平台开展采购业务，应自行对供应商的供货资质、产品质量等信息进行审核判断，甲方不对上述内容提供承诺或承担责任。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          2.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.5乙方向供应商发送《中选通知书》经供应商在系统操作“确认中选”后，乙方应及时生成交易订单并与供应商订立合同，乙方与供应商合同签订方式及条款由乙方与供应商自行商定。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 20pt; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          2.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.6乙方应妥善保管其在本平台的账号和密码、用于收付相关款项的银行卡卡号、密码、有效期等银行卡信息和在线收付软件（包括但不限于“在线支付”）的用户名及支付密码（包括但不限于数字密码），不得以任何形式出借、出租、转让前述账号、密码或其他信息，并应确保用于使用本平台的电脑终端、移动终端设备在安全、未被病毒袭击、未被入侵、未被监控、未被非法控制的环境下运行和使用。
          </font>
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              如因乙方未能履行上述妥善保管及安全使用义务而导致的任何损失或后果，均由乙方自行承担，本平台对此不承担任何赔偿或法律责任
            </font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="
          text-align: center;
          line-height: 21px;
          mso-line-height-rule: exactly
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第三条</font>
          &nbsp;
          <font face="仿宋_GB2312">违约处理</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 楷体_GB2312;
            mso-hansi-font-family: 宋体;
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          3.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            1乙方出现下列情形之一的，甲方有权暂停乙方在本平台使用询比价服务的资格6个月：
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">
            1）报价揭示后故意不发送《中选通知书》，私自与供应商线下达成交易的；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">
            2）供应商确认中选并缴纳服务费后乙方不及时生成采购订单拒绝交易，出现两次及以上的；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">
            3）乙方因拒绝交易被暂停过交易资格，再次出现供应商缴纳服务费后拒绝交易的；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">
            4）乙方发生破产、清算、重组，或者资信情况、经营状况恶化，甲方认为存在履约风险的;
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          3.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2如乙方受到中国石化处罚，被暂停或取消交易资格的，甲方有权按照中国石化对乙方的处罚时长暂停其使用询比价服务的权限。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            3.3乙方因上述3.1、3.2规定的情形被暂停询比价服务使用权限的，期满后，乙方可提出权限申请，经甲方审核满足条件的，可重新赋予使用权限。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">3.4乙方出现下列情形之一的，甲方有权</font>
          <font face="仿宋_GB2312">永久</font>
          <font face="仿宋_GB2312">取消乙方在本平台</font>
          <font face="仿宋_GB2312">使用询比价服务的资格</font>
          <font face="仿宋_GB2312">：</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          1
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ）引发重、特大质量事故或引发突发环境事件、环保处罚、生态损害赔偿等环保事件的；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">2）经法院审判认为乙方构成犯罪的;</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">（</font>
          <font face="仿宋_GB2312">
            3）乙方违反在易派客平台签署的《廉洁从业责任书》或《合规承诺函》的。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">使用询比价服务的资格取消后，乙方将无法在平台发布新的询价。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            3.5使用询比价服务的资格暂停或取消后，乙方将无法在平台发布新的询价单；已经询价但未明确中选结果的，采购商将无法再确定中选供应商，该询价单失效；已经中选的，由中选的供应商商决定是否继续开展交易。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">3</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">6</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          &nbsp;
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            乙方的行为违反上述多项条款的，按较重的规定处罚；出现多次违约行为，或在问题核实调查中态度恶劣，不积极配合的，视情况加重处理。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            3.7
            若乙方存在其他违反法律法规、本协议约定、其他平台协议或平台规则的，甲方有权酌情对乙方进行处理;甲方有权自行决定将乙方违约行为在平台公示，并有权决定暂停
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方使用本平台部分或全部功能</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          3.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">8本协议有效期间，乙方违反本协议或违法违规使用平台“询比价</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">服务</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">”功能开展业务，导致</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">本协议终止</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            ，或对甲方及第三方造成任何损害的，乙方应当向甲方及第三方承担损害赔偿责任（包括但不限于直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失）并消除影响，乙方向第三方承担损害赔偿责任后，无权向甲方追偿。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 'Times New Roman';
            mso-fareast-font-family: 宋体;
            font-size: 10.5pt;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="
          text-align: center;
          line-height: 21px;
          mso-line-height-rule: exactly
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第四条</font>
          <font face="仿宋_GB2312">&nbsp;保密条款</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            1
            双方应对本协议及因本协议的签订和履行而签署的其他协议中所约定属于保密信息的内容负有保密义务，未经书面授权，不得将保密信息以任何方式提供给第三方，不得将保密信息用于与本协议无关的活动、宣传，不得利用保密信息与披露方以外的第三方从事商业交易，但双方另有约定的除外。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.2
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            任一方有权根据法律法规的规定，或应司法机关、政府有关部门的要求，或基于依法依规开展的内部审计工作需要以及为开展投标工作需要而在必要范围内向有关第三方提供相关保密信息。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.3
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            本协议终止时，乙方所掌握的所有保密信息及其复印件，无论其为电子或书面等任何形式，均应立即销毁。本条约定的保密义务在本协议终止后仍然有效。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.4
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            本协议约定的保密信息是指：在乙方与甲方及平台采购商沟通交流过程中，一方以书面或口头等方式向乙方提供的通讯、信息、产品、数据、设计、图纸等资料，包括但不限于商业计划、贸易数据、财务数据、生产经营、专有技术、研究成果、技术秘密等。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5 以下各项不属于本协议所称“保密信息”：</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5.1在本协议签订时已为一方合法获取的信息；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5.2在本协议签订时已为公众所知的信息；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            5.3一方从不承担保密义务的第三方所获取的信息，并且以一方所了解为限，该第三方对该等信息的获取和/或披露不是非法的；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5.4在没有接触保密信息的情况下，一方独立开发取得的信息；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">5.5一方事先征得另一方书面同意而发布的信息。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="
          margin-top: 7.8pt;
          margin-bottom: 7.8pt;
          margin-left: 0pt;
          mso-para-margin-top: 0.5gd;
          mso-para-margin-bottom: 0.5gd;
          text-indent: 0pt;
          mso-char-indent-count: 0;
          mso-layout-grid-align: none;
          layout-grid-mode: char;
          text-align: left;
          line-height: 21px;
          mso-line-height-rule: exactly;
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          4.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            6
            双方一致认可，在乙方使用“询比价服务”功能过程中，一般不会向甲方披露任何保密信息。如乙方因本协议的履行确需向甲方披露任何保密信息的，应确保其向甲方提供的保密信息是其有权提供的，不会侵犯任何第三方的合法权益。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 'Times New Roman';
            mso-fareast-font-family: 宋体;
            font-size: 10.5pt;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="
          text-align: center;
          line-height: 21px;
          mso-line-height-rule: exactly
        "
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第五条</font>
          &nbsp;
          <font face="仿宋_GB2312">变更及终止</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 楷体_GB2312;
            mso-hansi-font-family: 宋体;
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">1双方经协商一致可变更或解除本合同。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            5.
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              2在不影响甲方本合同项下任何索赔权利的情况下，乙方有下列情形之一者，甲方有权单方书面通知乙方解除本合同，乙方应向甲方赔偿因此给甲方造成的损失：
            </font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.1未经甲方书面同意，将本合同项下部分或全部权利义务转让给第三方。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.2发生破产、清算、重整等情况，影响履约能力。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            2.3被中国石化暂停或取消交易资格，或被列入中国石化或物资装备部（国际事业公司）失信名单。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.4违反《廉洁从业责任书》或《合规承诺函》；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.5违反本合同项下合规条款；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.6违反本合同项下保密条款；</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          7
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            任何一方在本协议项下的承诺、声明或保证若在任一实质方面被证明是虚假的或具误导性的，或有其他严重违约行为，导致本合同目的无法实现；
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          8
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">发生其他严重影响甲方利益及本合同目的实现的重大事项。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            5.
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">
              3如因甲方业务调整，可提前30日书面通知乙方解除本协议，本协议自通知到达乙方且乙方7日内未提出书面异议后自动终止。
            </font>
          </span>
        </b>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.4
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          &nbsp;
          <font face="仿宋_GB2312">
            协议终止后乙方须继续对已发生但未完结的交易订单提供相关服务。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          5.5
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            本合同的解除、终止、无效、被撤销等均不影响乙方基于本合同项下服务与采购商订立的合同的履行。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第六条</font>
          &nbsp;
          <font face="仿宋_GB2312">合规条款</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            6.1甲、乙双方承诺已取得开展本协议项下业务所需的所有国家（地区）相关的执照、批准、许可、资质，知晓并严格遵守任何适用的国家（地区）的强制性法律法规。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            6.2乙方需确保本协议项下询比价交易真实性，且乙方在本平台上所有交易行为依法合规。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第七条</font>
          <font face="仿宋_GB2312">免责条款</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          7.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">1 不可抗力</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          7.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">1.1</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            不可抗力是在本合同订立后发生的一方或双方在订立本合同时不能预见、不能避免并不能克服的客观情况，不可抗力事件包括但不限于传染性疾病、自然灾害、战争、火灾、洪水、爆炸、暴乱、罢工等
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">，及不受甲方所控制的网络攻击、网络故障等。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            因不可抗力事件导致不能履行或不能如期履行本合同义务，遭受不可抗力的一方不承担违约责任。受不可抗力影响的一方应在不可抗力事件发生后
          </font>
          24小时内通知对方，并在其后14个日历日内向对方提供有效证明文件。任何一方故意或过失行为不应被视为不可抗力而免除责任。本合同项下付款义务不受不可抗力事件的影响。
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          7.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">1.2</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            受不可抗力影响一方应采取措施，将不可抗力造成的损失减少到最低限度，否则应承担因消极不作为而导致损失扩大的责任。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          7.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">1.3</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            如甲方因不可抗力导致不能按期履行本合同项下义务，乙方可以要求在不可抗力影响范围内顺延相关义务。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          7.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">1.4</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">如不可抗力事件影响持续</font>
          90（含）个日历日以上，双方将就
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">本合同项下</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            等相关问题进行协商。协商一致的，双方应签订变更合同；协商不成的，任何一方有权以书面形式要求解除本合同。因不可抗力事项导致合同解除的，甲乙各自承担因此造成的一切损失。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          7.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2 其他情形</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          7.
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">2.1</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">凡在本</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">平台</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">以</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">账号和密码登陆后进行的操作，均被视为</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">的行为，</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            当对以其账号进行的所有活动和事件以及通过其账号向易派客公司提交的文件材料承担全部法律责任。严禁
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">将其账号、密码转让或出租、出借予他人使用。如</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">乙方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">发现其账号遭他人非法使用，应立即通知</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">甲方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">如因乙方违反</font>
          <font face="仿宋_GB2312">1</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .2.5
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            的妥善保管及安全使用义务而导致的任何损失或后果，均由乙方自行承担，本平台对此不承担任何赔偿或法律责任。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            因网络黑客行为、用户故意或者过失导致账号、密码遭他人非法使用，
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">甲方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">不承担任何责任。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第八条</font>
          &nbsp;
          <font face="仿宋_GB2312">法律适用和争议解决</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">8</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            双方在履行本协议过程中如发生争议，应协商解决。协商不成的，提交甲方住所地有管辖权的法院解决。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-align: left; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        align="center"
        style="text-align: center; line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">第九条</font>
          &nbsp;
          <font face="仿宋_GB2312">生效及其它</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          .1
        </span>
        <b style="mso-bidi-font-weight: normal">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              mso-hansi-font-family: 'Times New Roman';
              mso-bidi-font-family: 'Times New Roman';
              mso-ansi-font-weight: bold;
              font-size: 12px;
              mso-font-kerning: 1pt;
            "
          >
            <font face="仿宋_GB2312">本协议一经乙方点击或勾选本页面上的</font>
            <font face="仿宋_GB2312">
              “同意”键将自动生效；供应商中选并支付服务费后，本协议履行完毕而自然终止
            </font>
          </span>
        </b>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9.2 甲方</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">
            有权根据国家法律法规变化及运营需要不时变更本协议，但变更后的协议将至少在平台上公示七日后方予实施，乙方应当及时查阅并了解相关变更内容。若乙方不同意变更后的协议，应自公示之日起七日内及时以书面形式向易甲方作出明确表示，否则，即表示乙方已接受变更后的协议，发生争议时，双方将以变更后的协议版本为准。如乙方不同意本协议变更后的内容并按前述期限及形式向甲方作出了明确表示，则乙方应及时按照变更前的协议内容履行完本协议项下相应责任义务。
          </font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            color: rgb(0, 0, 0);
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="line-height: 21px; mso-line-height-rule: exactly"
      >
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">9.3本协议未尽事宜，双方通过友好协商以补充</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">协议</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <font face="仿宋_GB2312">方式解决。</font>
        </span>
        <span
          style="
            mso-spacerun: 'yes';
            font-family: 仿宋_GB2312;
            mso-hansi-font-family: 'Times New Roman';
            mso-bidi-font-family: 'Times New Roman';
            font-size: 12px;
            mso-font-kerning: 1pt;
          "
        >
          <o:p></o:p>
        </span>
      </p>
    </div>`;
}
